// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import PostTile from 'church-theme-library/components/PostTile/PostTile'
import { formattedDate } from 'church-theme-library/utilities/date'

class PostSectionFeatureDouble extends React.Component {
	static defaultProps = {
		start: 0,
		end: undefined
	}

	render() {
		const { posts, end, loadingById } = this.props

		let featureMarkup = null,
			setA2Markup = null,
			mobileSlideMarkup = null

		featureMarkup = posts.slice( 0, 1 ).map( ( item ) => {
			return (
				<PostTile
					key={ item.id }
					url={ item.url }
					title={ item.title }
					excerpt={ item.excerpt }
					author={ item.author }
					date={ formattedDate( item ) }
					image={ item.featured_image }
					imageAlt={ item.title }
					sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 50vw` }
					className="is-feature"
					direction="vertical"
				/>
			)
		})

		setA2Markup = posts.slice( 1, end ).map( ( item ) => {
			return (
				<PostTile
					key={ item.id }
					url={ item.url }
					title={ item.title }
					author={ item.author }
					date={ formattedDate( item ) }
					image={ item.featured_image }
					imageAlt={ item.title }
					direction="horizontal"
					size="small"
				/>
			)
		})

		mobileSlideMarkup = posts.slice( 0, end ).map( ( item ) => {
			return (
				<section key={ item.id }>
					<PostTile
						url={ item.url }
						title={ item.title }
						author={ item.author }
						date={ formattedDate( item ) }
						image={ item.featured_image }
						imageAlt={ item.title }
						direction="vertical"
						size="small"
					/>
				</section>
			)
		})

		return (
			<React.Fragment>
				{/* Non-Mobile */}
				<section className="posts-section-feature-double">
					<main>
						{ featureMarkup }
					</main>

					<aside>
						{ setA2Markup }
					</aside>
				</section>

				{/* Mobile */}
				<section className="posts-slide">
					<div className="-heading">
						{/*<h2>The Latest</h2>*/}
					</div>

					<div className="-inner">
						{ mobileSlideMarkup }
					</div>
				</section>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		loadingById: state.page.loadingById
	}
}

export default connect( mapStateToProps )( PostSectionFeatureDouble )
